import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnglesDown} from "@fortawesome/free-solid-svg-icons";
import {Field, PrimitiveObject, RefField} from "../../../Types";
import {createRefKey, refConditionToFilters, selectRefData} from "./RefValueUI";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import {RefDataOI, setTableRefOpen} from "../../../features/tableSlice";
import styled from "styled-components";

interface PropsI {
    fieldSchema: Field & { ref: RefField },
    record: PrimitiveObject
}

export default function OpenRefButton({fieldSchema, record}: PropsI) {

    const filters = refConditionToFilters(fieldSchema.ref.condition, record);
    const refKey = createRefKey(filters, fieldSchema.ref.limit, fieldSchema.ref.order);

    const entityName = fieldSchema.ref.entity;
    const data = useAppSelector(selectRefData(entityName, refKey));
    const dispatch = useAppDispatch();

    if (!data)
        return null

    return <Button className={'btn-icon'} $isOpen={data.open}
                   onClick={() => dispatch(setTableRefOpen({entity: entityName, refKey, open: !data!.open}))}>
        <FontAwesomeIcon icon={faAnglesDown} className={'fa-color'} style={{width: "1.2rem", height: "1.2rem"}}/>
    </Button>
}

const Button = styled.button<{ $isOpen: boolean }>`
    margin-left: auto;

    rotate: x ${({$isOpen}) => $isOpen ? '180' : '0'}deg;


`
